module.exports = __webpack_public_path__ + "media/open-pk.d794475b.mp3";